
/**
 * 内部子菜单的高亮
 *
 * @param ev
 */
function highlightSubItem(ev: Event) {
  let li: Element,
    el: Element = ev.target as Element;

  if (el.tagName == "A" && el.getAttribute("target")) {
    li = el.parentNode as Element;
    li.querySelectorAll("li").forEach((_el: Element) => {
      if (_el == li) _el.classList.add("selected");
      else _el.classList.remove("selected");
    });
  }
}

export default {
  methods: {
    onClk(ev: Event): void {
      let children: HTMLCollection = this.$el.children;
      highlightSubItem(ev);
      let _btn: Element = ev.target as Element;

      if (
        _btn &&
        _btn.tagName == "H3" &&
        (_btn.parentNode as Element).tagName == "LI"
      ) {
        _btn = _btn.parentNode as Element;

        for (let btn: Element, i: number = 0, j = children.length; i < j; i++) {
          btn = children[i];
          let ul = btn.querySelector("ul");

          if (btn == _btn) {
            if (btn.className.indexOf("pressed") != -1) {
              btn.classList.remove("pressed"); // 再次点击，隐藏！
              if (ul) ul.style.height = "0px";
            } else {
              if (ul) ul.style.height = ul.scrollHeight + "px";
              btn.classList.add("pressed");
            }
          } else {
            btn.classList.remove("pressed");
            if (ul) ul.style.height = "0px";
          }
        }
      } else return;
    },
  },
};
